import { CampaignDonorsState } from "./recommendedUsers.types";

export const initialState: CampaignDonorsState = {
  data: [],
  loading: false,
  error: null,
};
